import {useMedia} from "@hooks/ui/useMedia";
import PopoverCustom from "@ui/popover/PopoverCustom";
import ModalCustom from "@ui/modal/ModalCustom";
import {ReactElement} from "react";

const ModalWithPopover = ({
                              component,
                              button,
                              label,
                              closeMenuFn,
                              onOpenChange,
                          }: {
    component: ReactElement
    button: ReactElement
    label?: string
    closeMenuFn?: () => void
    onOpenChange?: (open: boolean) => void
}) => {
    const {isDesktop} = useMedia()

    if (isDesktop) {
        return (
            <PopoverCustom
                component={component}
                button={button}
                closeMenuFn={closeMenuFn}
                onOpenChange={onOpenChange}
            />
        )
    }
    return (
        <ModalCustom
            label={label}
            component={component}
            button={button}
            closeMenuFn={closeMenuFn}
        />
    )
};
export default ModalWithPopover
